module.exports = __webpack_public_path__ + "static/img/style_3.42cce0e0.png";